export default __webpack_public_path__ + "static/media/animals.864abbca.svg";